import { Box, capitalize } from "@mui/material"
import { AddOutlined } from "@mui-symbols-material/w300"
import type { FC } from "react"

import { Button } from "@/components/common/Button"
import PageTabs from "@/components/common/PageTabs/PageTabs"
import type { CompanyRegistration, CompanyRegistrationType, SignedUrl } from "@/graphql/codegen/graphql"
import { CompanyRegistrationType as CompanyRegistrationTypes } from "@/graphql/codegen/graphql"
import RegistrationTable from "@/screens/CompanySettings/Registration/tables/RegistrationTable"
import type { OpenRegistrationDialogFn } from "@/screens/CompanySettings/Registration/types"

const RegistrationTabs: FC<{
  list: CompanyRegistration[]
  fileData: SignedUrl[]
  openRegistrationDialog: OpenRegistrationDialogFn
  onRemove: (registration: CompanyRegistration) => void
}> = ({ list, fileData, openRegistrationDialog, onRemove }) => {
  const hasFederal = list.some((registration) => registration.registrationType === CompanyRegistrationTypes.Federal)

  // Show "Add" button for federal tab only if there is no federal registration
  const shouldShowAddButton = (tab: CompanyRegistrationType) =>
    tab === CompanyRegistrationTypes.Federal ? !hasFederal : true
  return (
    <PageTabs<CompanyRegistrationType>
      tabs={[CompanyRegistrationTypes.Federal, CompanyRegistrationTypes.State, CompanyRegistrationTypes.Local]}
      renderContent={(tab: CompanyRegistrationType) => (
        <Box className='grow overflow-hidden'>
          <RegistrationTable
            tab={tab}
            data={list}
            fileData={fileData}
            openRegistrationDialog={openRegistrationDialog}
            onRemove={onRemove}
          />
        </Box>
      )}
      renderSideContent={(tab: CompanyRegistrationType) => {
        return shouldShowAddButton(tab) ? (
          <Button
            appearance='outlined'
            startIcon={<AddOutlined />}
            onClick={() =>
              openRegistrationDialog({
                tab,
              })
            }
          >
            Add {capitalize(tab.toLowerCase())} Registration
          </Button>
        ) : null
      }}
    />
  )
}
export default RegistrationTabs
